import { Formflow, Section } from '@components/FormFlow/FormflowComponent';
import ISection from '@components/FormFlow/Interfaces/ISection';
import IProcess from '@components/FormFlow/Interfaces/Process';
import ModalHeader from '@components/GoEpikUI/Modal-related/ModalHeader';
import ComponentPreview from '@components/process/ComponentPreview';
import ConfigProcessComponent from '@components/process/ConfigProcessComponent';
import MenuComponent from '@components/process/MenuComponents';
import ProcessComponent from '@components/process/ProcessComponent';
import ProcessContext from '@components/process/ProcessContext';
import ProcessPage from '@components/process/ProcessPage';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import returnDesc from '@helpers/gifsHelpers/descReturner';
import returnGif from '@helpers/gifsHelpers/gifReturner';
import { ComponentType } from '@interfaces/component-type';
import { Routes } from '@src/helpers/_routes';
import NotificationComponent from '@src/helpers/_showNotifications';
import ProcessRequestsInterceptor from '@src/helpers/interceptors/ProcessRequestInterceptor';
import I18n from '@src/i18n';
import { Theme } from '@src/styled-components';
import { Button, Checkbox, Col, Form, Input, Modal, Row } from 'antd';
import FormItem from 'antd/lib/form/FormItem';
import React from 'react';
import { Redirect } from 'react-router';
import { arrayMove, SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import styled from 'styled-components';
import { faGripVertical } from '@fortawesome/free-solid-svg-icons';
import uuidv4 from 'uuidv4';

import { LocalStorageKeys } from './App';
import GroupService from '@services/graphQL/graphQLGroup'

const groupService = new GroupService()
const DragHandle = SortableHandle(() => <Icon icon={faGripVertical} className="drag-icon" />)
const SortableItem = SortableElement<any>(({ value }) => <li style={{ listStyleType: "none" }}>{value}</li>);
const SortableList = SortableContainer<any>(({ items }) => {
  return (
    <div >
      {items.map((value: any, index: number) => (
        <SortableItem key={`item-${index}`} index={index} value={value} />
      ))}
    </div>
  );
});

interface IProcessContainerProps {
  match: any;
  form: any;
}

interface IProcessContainerState {
  process: any
  processPages: any
  componentsVisible: boolean;
  processComponets: any;
  currentPage: any;
  currentPageIdx: number;
  configComponent: boolean;
  isDescription: any;
  isRequired: any;
  currentComponent: Object;
  duplicatedPage: any;
  currentComponentIdx: number;
  selectedComponent: string;
  selectedComponentGifPath: any;
  modalVisible: boolean;
  modal2Visible: boolean;
  forceReload: boolean;
  redirect: boolean;
  isLoaded: boolean;
  isGroupModalVisible: boolean;
  userGroups: any;
  selectedUserGroups: any;
  processComponetListKey: any;
}

export default class ProcessContainer extends React.Component<IProcessContainerProps, IProcessContainerState> {
  private _processService: ProcessRequestsInterceptor;
  private idUnit: string = '';
  lateralBottom: any;
  contentBottom: any;
  constructor(props: IProcessContainerProps) {
    super(props);
    this._processService = new ProcessRequestsInterceptor();
    this.idUnit = String(localStorage.getItem(LocalStorageKeys.ACTIVE_UNIT_ID))

    this.state = {
      process: new Formflow(),
      processPages: [new Section()],
      componentsVisible: false,
      processComponets: [],
      currentPageIdx: 0,
      configComponent: false,
      isDescription: false,
      isRequired: false,
      currentComponent: {},
      duplicatedPage: {},
      currentComponentIdx: 0,
      selectedComponent: '',
      selectedComponentGifPath: '',
      currentPage: [],
      redirect: false,
      isLoaded: false,
      modalVisible: false,
      modal2Visible: false,
      forceReload: false,
      isGroupModalVisible: false,
      userGroups: [],
      selectedUserGroups: [],
      processComponetListKey: uuidv4()
    }
    this.getProcess = this.getProcess.bind(this);
    this.handleUpdateSortableListKey = this.handleUpdateSortableListKey.bind(this)
  }

  // Isso existe para que o uploadComponent re-renderize a lista após o onChange (após upload de arquivo).
  // É necessário, pois só atualizar o state não está refletindo no componente de upload.
  handleUpdateSortableListKey() {
    this.setState({ processComponetListKey: uuidv4() })
  }

  componentWillMount() {
    this.initialData()
  }

  initialData = async () => {
    if (this.props.match.params.id) {
      await this.getProcess(this.props.match.params.id);
    } else {
      let modalOnboarding: any = localStorage.getItem(LocalStorageKeys.MODAL_ONBOARDING)
      this.setState((state) => ({
        modalVisible: (modalOnboarding === 'true'),
        isLoaded: true,
        currentPage: state.processPages[0]
      }))
    }
  }
  
  componentDidMount() {
    this.getUserGroups();
  }

  getUserGroups = async () => {
    let { listUserGroups }: any = await groupService.listUserGroups()
    this.setState({ userGroups: listUserGroups })
  }

  setForceReload = async () => {
    this.setState({ forceReload: true })
  }
  async getProcess(formflowId: string) {
    try {
      let process: any = undefined;
      process = await this._processService.getById<IProcess>(formflowId, this.idUnit);
      this.setState((state) => ({
        process,
        processPages: process.sections,
        selectedUserGroups: process.groupId,
        currentPage: process.sections[state.currentPageIdx]
      }))
      const page = Object.assign(this.state.processPages[this.state.currentPageIdx])
      page.active = true;
      await this.forceUpdate()
    }
    catch (e) {
      console.log("formflow error", e);
    }

    this.setState({
      isLoaded: true
    });
  }

  onSaveProcess = async () => {
    const newProcess = Object.assign(this.state.process)
    newProcess.sections = this.state.processPages
    await this.forceUpdate()
    this.props.form.validateFields((err: any, values: any) => {
      if (!err) {   
      }
    });
    
    const { process } = this.state
    process.groupId = this.state.selectedUserGroups
    this.setState({process})

    try {
      await this.onValidateProcess();
      if (this.state.process.sections) {
        const newProcess = {...this.state.process} 
        newProcess.sections = newProcess.sections.map((r: any) => {
          if (r.next === 'end') r.next = null
          return r
        })
        await this.setState({process: newProcess})
      }
      if (this.state.process.id) {

        await this._processService.updateById(String(this.state.process.id), this.idUnit, this.state.process)
      }
      else {
        await this._processService.create(this.state.process, this.idUnit);
      }
      
      NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("process.saveSucessfully"));
      this.setState({ redirect: true })
    } catch (errors) {
      let newError: string = ''
      for (let error of errors) {
        if (error == I18n.l("api.PROCESS_SECTIONS_NOT_USED")) {
          newError = error
        }
        else if (error == I18n.l("api.CONDITION_LOOP")) {
          newError = error
        }
      }
      if (newError !== I18n.l("api.PROCESS_SECTIONS_NOT_USED") && newError !== I18n.l("api.CONDITION_LOOP")) {
        console.warn(newError);
        NotificationComponent.Notify('error', I18n.l("form.filter.errors.register"), I18n.l("label.pages.processIncompleted"))
      }
      else {
        NotificationComponent.Notify('error', I18n.l("form.filter.errors.register"), errors);
      }
    }
  }

  onValidateProcess = async () => {
    const pageValidated = Object.assign(this.state.processPages)
    
    for (let [idxPage, items] of this.state.processPages.entries()) {
      
      if (items.components.length === 0 || items.components === undefined) {
        pageValidated[idxPage].componentInvalid = true
      }
      else { pageValidated[idxPage].componentInvalid = false; }
      if (items.title === '' || items.title === undefined) {
        pageValidated[idxPage].componentInvalid = true
      }
      else { pageValidated[idxPage].componentInvalid = false; }
      for (let [idxComponent, component] of items.components.entries()) {
        if (component.title === '' || component.title === undefined) {
          pageValidated[idxPage].componentInvalid = true;
          component.title = ''
        }
        else { pageValidated[idxPage].componentInvalid = undefined; }
        if (component.type === ComponentType.CALCULATOR && component.formula === "") {
          pageValidated[idxPage].componentInvalid = true;
          component.formula = ''
        }
        else { pageValidated[idxPage].componentInvalid = undefined; }
        if (component.type === ComponentType.SAMPLEIMAGE || component.type === ComponentType.SAMPLEVIDEO) {
          if (component.url === '' || component.url === undefined) {
            pageValidated[idxPage].componentInvalid = true;
            component.url = ''

          }
        }
        if (component.options) {
          for (let [idxOption, option] of component.options.entries()) {
            if (component.type === ComponentType.SELECT) {
              if (option.value === '' || option.value === undefined) {
                pageValidated[idxPage].componentInvalid = true;
                option.value = '';
              }
            } 
            if (component.type === ComponentType.GOTO) {
              if (option.label === '' || option.label === undefined || option.sectionId === undefined || option.sectionId === null) {
                pageValidated[idxPage].componentInvalid = true;
                option.label = '';
              }
            }
          }
        }
      }
    }
    this.setState({ processPages: this.state.processPages })
  }

  onProcessNameChange = (value: any) => {
    const process: IProcess = this.state.process;
    process.name = value.target.value;
    this.setState({
      process
    });
  }

  //#region Pages 
  handleInputTitleChange = (idx: any) => async (evt: any) => {
    const newProcessPages = this.state.processPages.map((page: ISection, sidx: number) => {
      if (idx !== sidx) return page;
      return { ...page, title: evt.target.value };
    });
    this.setState({
      processPages: newProcessPages,
    });
  }

  handleAddNewPage = async () => {
    const newPage = new Section();
    const lastItem = this.state.processPages.length - 1;
    this.state.processPages[lastItem].next = newPage.id
    this.setState({
      processPages: this.state.processPages.concat([newPage]),
    });
    this.lateralBottom.scrollIntoView({ behavior: 'smooth' });
  }
  setNewIDSComponents = async (components: any, idx: number) => {
    const newComponent = components.map((items: any) => {
      return { ...items, id: Math.random().toString(36).substr(2, 9) }
    })
    let newStateComp = this.state.processPages;
    const newPage = Object.assign({}, newStateComp[idx], { id: Math.random().toString(36).substr(2, 9), title: newStateComp[idx].title, components: newComponent })
    newStateComp[idx].next = newPage.id
    newStateComp.splice(idx + 1, 0, newPage)
    this.setState({ processPages: newStateComp })
  }

  handleDuplicatePage = async (idx: number) => {
    let newComponent: any = []
    for (let component of this.state.processPages[idx].components) {
      newComponent.push(component)
    }
    await this.setNewIDSComponents(newComponent, idx)
  }

  handleRemovePage = (index: number, section: ISection) => async () => {
    const newPages = Object.assign({}, this.state.processPages)
    const previousItem = this.state.processPages[index - 1];
    const nextItem = this.state.processPages[index + 1];
    if (!nextItem && previousItem) {
      previousItem.next = null
    }
    if (nextItem && previousItem) {
      previousItem.next = nextItem.id
    }


    let filteredProcess = this.state.processPages.filter((section: any, sindex: number) => index !== sindex)
    let newCurrentPageIdx = (this.state.processPages.length - 1) === index && index !== 0 ? index - 1 : index
    await this.setState({
      currentPageIdx: newCurrentPageIdx
    });
    
    for (let [idx, page] of filteredProcess.entries()) {
      if (page.conditions) {
        const findConditionPage = page.conditions.find((e: any) => e.sectionId === this.state.currentPage.id)
        if (findConditionPage !== undefined) {
          newPages[idx].isBroken = true
        }
      }
    }    
    if (filteredProcess.length === 0) {
      await this.setState({
        processPages: [new Section()],
        currentPageIdx: 0
      });
    }else{
      const process = await this.setNextPages(filteredProcess)
      await this.setState({ processPages: process })
    }

  }

  getPagesGoThisPage(idPage: string) {
    const selectTitles = [];
    for (let page of this.state.processPages) {
      if (page.next === idPage) {
        selectTitles.push(page.title)
      }
    }
    return selectTitles
  }

  getPagesSelect(idPage: string) {
    const selectTitles: string[] = [];

    this.state.processPages.forEach((page: any) => {
      if (page.id) {
        selectTitles.push(page);
      }

      const indexSelectSection = selectTitles.findIndex((idTitle: any) => idTitle.id === idPage)

      if (indexSelectSection > -1) {
        selectTitles.splice(indexSelectSection)
      }
    })
    return selectTitles;
  }

  sectionLinkOnChange = (idx: number) => async (evt: any) => {
    const newSection = Object.assign({}, this.state.processPages);
    if (evt === 'end') {
      newSection[idx].next = null
    }
    else {
      newSection[idx].next = evt
    }
    this.setState({ processPages: this.state.processPages })
  }

  removeConditions = async () => {
    //verificar essa locura abaixo!
    const currentPage = Object.assign(this.state.processPages)
    currentPage[this.state.currentPageIdx].conditions = null;
    this.setState({ processPages: this.state.processPages, forceReload: true })
  }

  renderProcessPages() {
    let pages: JSX.Element[] = []
    for (let [idx, page] of this.state.processPages.entries()) {
      pages.push(
        <div className="page-container">
          <ProcessPage
            key={idx}
            setCurrentPage={() => this.setCurrentPage(idx)}
            onTitlePageChange={() => this.handleInputTitleChange(idx)}
            titlePageValue={page.title !== undefined ? page.title : ''}
            onClickRemoveButton={() => this.handleRemovePage(idx, page)}
            onDuplicatePage={() => this.handleDuplicatePage(idx)}
            idxPage={idx}
            sectionLinkedSelect={page.next ? page.next : 'end'}
            sectionLinked={this.getPagesSelect(page.id)}
            pagesGoThisPage={this.getPagesGoThisPage(page.id)}
            sectionLinkOnChange={() => this.sectionLinkOnChange(idx)}
            isActive={this.state.processPages[idx].active}
            currentPage={page}
            valueIDPage={page.title !== undefined ? page.title : ''}
            pageComponents={page.components}
            isBroken={page.isBroken}
            componentsInvalid={page.componentInvalid}
            removeConditions={() => this.removeConditions()}
          />
          {this.state.processPages[idx].next === null && (
            <div className="page-end"></div>
          )
          }
        </div>
      )
    }
    return pages;
  }

  setNextPages = async (process: any, orderAuto?: boolean) => {    
    for (let [i, items] of process.entries()) {
      // console.log('i, items',i,items);
      if (!items.forceNext && orderAuto && (items.conditions === undefined || items.conditions === null)) {
        console.log('true');
        const key = parseInt(i)
        if (process[key + 1]) {
          process[key].next = process[key + 1].id
        } else {
          process[key].next = null
        }
      }
    }
    for (let i in process) {
      const key = parseInt(i)
      if (process[key].components) {
        for (let component of process[key].components) {
          if (component.type === ComponentType.GOTO) {
            for (let opt of component.options) {
              const todoPage = process.findIndex((item: any) => item.id === opt.sectionId)
              process[todoPage].grouped = true;
              if (process[todoPage - 1] && process[todoPage - 1].next === opt.sectionId) {
                process[todoPage - 1].next = null
              }
            }
          }
        }
      }
    }
    return process
  }

  onSortEndPage = async ({ oldIndex, newIndex }: { oldIndex: number, newIndex: number }) => {

    if (oldIndex !== newIndex) {
      const process = await this.setNextPages(arrayMove(this.state.processPages, oldIndex, newIndex), true);
      this.setState({
        processPages: process
      })
    }
  };

  setCurrentPage = async (idx: number) => {    
    // this.setState({ currentPageIdx: idx })
    const previousPage = Object.assign(this.state.currentPage)
    previousPage.active = false;
    const newPage = Object.assign(this.state.processPages[idx])
    newPage.active = true;
    this.setState({
      currentPage: newPage,
      currentPageIdx: idx
    })
  }
  //#endregion

  //#region Components
  showComponents = async () => {
    this.setState({ componentsVisible: !this.state.componentsVisible })
    this.contentBottom.scrollIntoView({ behavior: 'smooth' });
  }

  handleAddNewComponent = async (type: ComponentType) => {
    const newComponent = Object.assign(this.state.processPages[this.state.currentPageIdx])
    newComponent.components = newComponent.components.concat([{ id: Math.random().toString(36).substr(2, 9), type, required: false, title: undefined }])
    await this.setCurrentComponent(newComponent.components.length - 1)
    this.setState({
      processPages: this.state.processPages,
      componentsVisible: false,
      configComponent: type === ComponentType.CALCULATOR || type === ComponentType.MODEL ? true : false,
    });
    this.contentBottom.scrollIntoView({ behavior: 'smooth' });
  }
  handleRemoveComponent = (index: number) => async () => {
    const newCurrentComponent = Object.assign(this.state.processPages[this.state.currentPageIdx].components[index])
    this.setState({
      currentComponent: newCurrentComponent,
      configComponent: false
    })
    const newPage = Object.assign(this.state.processPages)
    const newComponent = Object.assign(this.state.processPages[this.state.currentPageIdx])
    newComponent.components = newComponent.components.filter((section: any, sindex: number) => index !== sindex),
      this.setState({
        processPages: this.state.processPages,
        forceReload: true
      });
    for (let [idx, page] of this.state.processPages.entries()) {
      if (page.conditions) {
        for (let items of page.conditions) {
          const findConditionPage = items.rules.find((e: any) => e.xItem.id === newCurrentComponent.id)
          if (findConditionPage !== undefined) {
            newPage[idx].isBroken = true
          }
        }
      }
    }
    this.setState({
      processPages: this.state.processPages,
    });
  }

  handleDuplicateComponent = async (idx: number) => {
    const newComponent = Object.assign({}, this.state.processPages[this.state.currentPageIdx].components[idx], { id: Math.random().toString(36).substr(2, 9) })

    this.state.processPages[this.state.currentPageIdx].components.splice(idx + 1, 0, newComponent)
    await this.forceUpdate()
    // this.contentBottom.scrollIntoView({ behavior: 'smooth' });
  }
  handleConfigComponent = (type: number) => (
    ![
      ComponentType.SAMPLETEXT,
      ComponentType.SAMPLEIMAGE,
      ComponentType.SAMPLEVIDEO
    ].includes(type)
  )
  setCurrentComponent = async (idx: number) => {
    const previousComponent = Object.assign(this.state.currentComponent)
    previousComponent.active = false;
    const newComponent = Object.assign(this.state.processPages[this.state.currentPageIdx].components[idx])
    newComponent.active = true;
    newComponent.maxRepeat = 999;
    let hasConfig = this.handleConfigComponent(newComponent.type)
    this.setState({
      currentComponent: newComponent,
      configComponent: hasConfig,
      currentComponentIdx: idx
    })
  }

  handleInputTitleComponentChange = (idx: any) => async (evt: any) => {
    const newComponent = Object.assign(this.state.processPages[this.state.currentPageIdx])
    newComponent.components[idx].title = evt.target.value
    this.setState({
      processPages: this.state.processPages,
    });
    await this.onValidateProcess();
  }

  handleInputDescriptionComponentChange = (idx: any) => async (evt: any) => {
    const newComponent = Object.assign(this.state.processPages[this.state.currentPageIdx])
    newComponent.components[idx].description = evt.target.value
    this.setState({
      processPages: this.state.processPages,
    });
  }

  handleIsRequiredComponentChange = (idx: any) => async (evt: any) => {

    const newComponent = Object.assign(this.state.processPages[this.state.currentPageIdx])

    newComponent.components[idx].required = evt.target.checked
    if (newComponent.components[idx].required) {
      newComponent.components[idx].minRepeat = 1;
      newComponent.components[idx].minMultiple = 1;
      newComponent.components[idx].maxMultiple = 999;

    }
    else {
      newComponent.components[idx].minRepeat = 0;
      newComponent.components[idx].minMultiple = 0;
      newComponent.components[idx].maxMultiple = 999;
    }
    this.setState({
      processPages: this.state.processPages,
    });
  }

 

  handleIsMinMultipleComponentChange = (idx: any) => async (evt: any) => {
    const newComponent = Object.assign(this.state.processPages[this.state.currentPageIdx])
    newComponent.components[idx].minMultiple = evt
    this.setState({
      processPages: this.state.processPages,
    });
  }
  
  handleIsMaxMultipleComponentChange = (idx: any) => async (evt: any) => {
    const newComponent = Object.assign(this.state.processPages[this.state.currentPageIdx])
    newComponent.components[idx].maxMultiple = evt
    this.setState({
      processPages: this.state.processPages,
    });
  }

  handleIsRepeatComponentChange = (idx: any) => async (evt: any) => {

    const newComponent = Object.assign(this.state.processPages[this.state.currentPageIdx])
    if (newComponent.components[idx].type === ComponentType.SELECT) {
      newComponent.components[idx].multiple = evt.target.checked
    }
    newComponent.components[idx].repeat = evt.target.checked
    if(!evt.target.checked && (newComponent.components[idx].minMultiple || newComponent.components[idx].maxMultiple)){
      newComponent.components[idx].minMultiple = 0;
      newComponent.components[idx].maxMultiple = 999;

    }
    if (newComponent.components[idx].repeat) {
      newComponent.components[idx].maxRepeat = 100;
    }
    else {
      newComponent.components[idx].maxRepeat = 1;
    }
    this.setState({
      processPages: this.state.processPages,
    });
  }

  handleIsHourInsertionAllowed = (idx: any) => async (evt: any) => {
    const newComponent = Object.assign(this.state.processPages[this.state.currentPageIdx])
    newComponent.components[idx].hour = evt.target.checked
    this.setState({ processPages: this.state.processPages})
  }

  onChangeComponentValue = (idx: any) => async (evt: any) => {
    const newComponent = Object.assign(this.state.processPages[this.state.currentPageIdx])
    if (newComponent.components[idx].type === ComponentType.SAMPLEIMAGE || newComponent.components[idx].type === ComponentType.SAMPLEVIDEO) {
      newComponent.components[idx].url = evt
    }
    if (newComponent.components[idx].type === ComponentType.SELECT || newComponent.components[idx].type === ComponentType.GOTO || newComponent.components[idx].type === ComponentType.SAMPLE) {
      newComponent.components[idx].options = evt
      //newComponent.components[idx].maxMultiple = newComponent.components[idx].options.length
    }
    await this.setState({
      processPages: this.state.processPages,
    });
    await this.onValidateProcess();
    if (newComponent.components[idx].type === ComponentType.GOTO) {
      const process = await this.setNextPages(this.state.processPages)
      this.setState({
        processPages: process,
        forceReload: true
      })
    }
  }


  renderProcessComponents() {
    let components: JSX.Element[] = [];
    if (this.state.processPages.length > 0 && this.state.processPages[this.state.currentPageIdx].components !== undefined) {
      for (let [idx, component] of this.state.processPages[this.state.currentPageIdx].components.entries()) {
        components.push(
          <div >
            <ProcessComponent
              key={idx}
              onTitleComponentChange={() => this.handleInputTitleComponentChange(idx)}
              titleComponentValue={component.title || ''}
              onDescriptionComponentChange={() => this.handleInputDescriptionComponentChange(idx)}
              descriptionComponentValue={component.description !== undefined ? component.description : ''}
              onClickRemoveButton={() => this.handleRemoveComponent(idx)}
              onDuplicateComponent={() => this.handleDuplicateComponent(idx)}
              onEditComponent={() => this.setCurrentComponent(idx)}
              idComponent={component.id}
              ConfigComponent={this.handleConfigComponent(component.type)}
              typeComponent={component.type}
              enableDescription={component.description ? true : false}
              isActive={this.state.processPages[this.state.currentPageIdx].components[idx].active}
              currentComponent={this.state.currentComponent}
              url={component.url ? component.url : undefined}
              options={component.options}
              onChangeComponentValue={() => this.onChangeComponentValue(idx)}
              isRepeat={component.repeat}
              isRequired={component.required}
              drag={<DragHandle />}
              handleUpdateSortableListKey={this.handleUpdateSortableListKey}
            />
          </div>
        )
      }
    }
    return components;
  }

  onSortEndComponent = async ({ oldIndex, newIndex }: { oldIndex: number, newIndex: number }) => {
    const newComponent = Object.assign(this.state.processPages[this.state.currentPageIdx])

    newComponent.components = arrayMove(newComponent.components, oldIndex, newIndex)
    this.setState({
      processPages: this.state.processPages
    });
  };

  toggleDescription = async (enabled: any) => {
    this.setState({ isDescription: enabled })
  }

  onSaveComponent = async () => {
    this.setState({ configComponent: false })
  }

  changeMenuText = async (selectedComponent: string) => {
    this.setState({ selectedComponent })
  }

  changeComponentValue = async (component: any) => {
    const { currentPageIdx, currentComponentIdx } = this.state
    const updatedComponent = Object.assign(this.state.currentComponent, component)
    const newComponent = Object.assign(this.state.processPages[currentPageIdx])
    newComponent.components[currentComponentIdx] = updatedComponent
  }

  changeConditionValue = async (condition: any, elseLink?: string, forceNext?: boolean) => {
    const { currentPageIdx } = this.state
    const newComponent = Object.assign(this.state.processPages[currentPageIdx])
    if (condition && condition.length > 0) {
      newComponent.conditions = condition
    }
    else {
      newComponent.conditions = undefined
    }
    this.setState({ forceReload: true })
    if (newComponent.conditions) {
      for (let items of condition) {
        if (items.sectionId !== undefined) {
          newComponent.isBroken = undefined
        }
        for (let rules of items.rules) {
          if (rules.xItem.id !== undefined) {
            newComponent.isBroken = undefined
          }
        }
      }
    }
    const process = await this.setNextPages(this.state.processPages)
    newComponent.forceNext = forceNext
    newComponent.next = elseLink
    this.setState({ processPages: process })
  }

  setOnboardingLocalStorage = () => {
    this.setState({ modal2Visible: false })
    localStorage.setItem(LocalStorageKeys.MODAL_ONBOARDING, 'false')
  }

  openGroupModal = async () => {
    this.setState({isGroupModalVisible: true})
  }
  closeGroupModal = async () => {
    this.setState({isGroupModalVisible: false})
  }

  handleGroupPermissionAdd = async (e: any) => {
    if(!this.state.selectedUserGroups){
      this.setState({selectedUserGroups: []})
    }
    let {selectedUserGroups} = this.state
    
        if(e.target.checked){
            selectedUserGroups.push(e.target.value)
        } else {
          selectedUserGroups = selectedUserGroups.filter((group: any) => group !== e.target.value)
        }
        this.setState({selectedUserGroups})
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { userGroups } = this.state
    return (
      <Wrapper>
        {this.state.redirect &&
          <Redirect
            push
            to={Routes.formflowProcess}
            from={`${Routes.componentFormflow}/${this.state.process.id}`}
            strict
          />
        }
        <Modal
          visible={this.state.modalVisible}
          closable={false}
          footer={[
            <Button type="primary" key="ok" onClick={() => this.setState({ modalVisible: false, modal2Visible: true })}>
              {I18n.l('common.ok')}
            </Button>
          ]}
          style={{ top: 350 }}
        >
          <p>{I18n.l('onboarding.modal.one')}</p>
        </Modal>

        <Modal
          visible={this.state.modal2Visible}
          closable={false}
          footer={[
            <Button type="primary" key="ok" onClick={this.setOnboardingLocalStorage}>
              {I18n.l('common.ok')}
            </Button>
          ]}
          style={{ top: 350 }}
        >
          <p>{I18n.l('onboarding.modal.two')}</p>
        </Modal>

        <ProcessContext.Provider
          value={{
            updateProcessComponent: this.changeComponentValue,
            updateProcessCondition: this.changeConditionValue,
            currentPage: this.state.currentPage,
            pages: this.state.processPages,
            idxCurrentPage: this.state.currentPageIdx
          }}
        >
          {!this.state.isLoaded &&
            <span style={{ marginLeft: '1rem' }}>{I18n.l("common.loadingData")}</span>
          }
          {this.state.isLoaded &&
            <>
              <HeaderWrapper>
                <div className="allowed-group-select">
                  <Button onClick={this.openGroupModal} type="primary" className="group-modal-button">{I18n.l('group.select')}</Button>
                </div>
                <Modal
                className={"no-padding"}
                closable={false}
                visible={this.state.isGroupModalVisible}
                onOk={this.closeGroupModal}
                width={'36%'}
                onCancel={this.closeGroupModal}
                >
                  <ModalHeader lowercase={true}>
                    <h3>{I18n.l('select.allowed.process.groups')}</h3>
                  </ModalHeader>
                  <GroupsModalContainer>
                    <div className="checkboxes">
                    {userGroups && userGroups.length > 0  && userGroups.map((userGroup: any) => {
                      return <Checkbox style={{marginLeft: 0}} value={userGroup.id} onChange={this.handleGroupPermissionAdd} checked={this.state.selectedUserGroups ? this.state.selectedUserGroups.includes(userGroup.id) : false} key={userGroup.id}><p>{userGroup.name}</p></Checkbox>
                    })}
                    </div>
                  </GroupsModalContainer>
                </Modal>
                <div className="header-form">
                    <Form onSubmit={this.onSaveProcess}>
                      <FormItem className='header-padding'>
                        {getFieldDecorator('input', {
                          rules:
                            [
                              { required: true, message: I18n.l("form.validation.field.required") },
                              {
                                min: 3, message: I18n.l('formflow.labels.validationToShort')
                              },
                            ],
                          initialValue: this.state.process.name
                        })(
                          <Input
                            className='input-name-process'
                            size='large'
                            placeholder={I18n.l('label.nameProcess')}
                            onChange={this.onProcessNameChange}
                            maxLength={50}
                            minLength={3}
                          />
                        )}
                        <Button className="button-cancel" type="primary" ghost onClick={() => this.setState({ redirect: true })} >{I18n.l('common.cancel')}</Button>
                        <Button className="button-save " type="primary" onClick={this.onSaveProcess} >{I18n.l('common.save')}</Button>
                      </FormItem>
                    </Form>
                </div>
              </HeaderWrapper>
              <Row>
                <Col xl={5} xxl={5}>
                  <LateralMenuWrapper style={this.state.configComponent ? { backgroundColor: ' #F6FCFD' } : {}}>
                    {!this.state.configComponent &&
                      <>
                        <h1 style={{ paddingLeft: '38px' }}>{I18n.l('label.pages')}</h1>
                        <SortableList items={this.renderProcessPages()} onSortEnd={this.onSortEndPage} />
                        <Row className='cursor-page-style'>
                          <Col onClick={this.handleAddNewPage} xl={6} xxl={4} >
                            <Icon color=' #1890ff' size='3x' icon={faPlusCircle} />
                          </Col>
                          <Col onClick={this.handleAddNewPage} className='add-button-style' xl={14} xxl={10} >
                            {I18n.l('process.addPage')}
                          </Col>
                        </Row>
                      </>
                    }
                    {this.state.configComponent &&
                      <>
                        <div style={{ padding: '0 20px 0 20px' }}>
                          <Button
                            onClick={this.onSaveComponent}
                            className='register-button'
                            style={{ width: '100%' }}
                          >
                            {I18n.l('label.saveConfigComponent')}
                          </Button>
                        </div>
                        <ConfigProcessComponent
                          onChangeDescription={this.toggleDescription}
                          currentComponent={this.state.currentComponent}
                          onChangeRequired={this.handleIsRequiredComponentChange(this.state.currentComponentIdx)}
                          onChangeRepeat={this.handleIsRepeatComponentChange(this.state.currentComponentIdx)}
                          onChangeHourInsertion={this.handleIsHourInsertionAllowed(this.state.currentComponentIdx)}
                          onChangeMin={() => this.handleIsMinMultipleComponentChange(this.state.currentComponentIdx)}
                          onChangeMax={() => this.handleIsMaxMultipleComponentChange(this.state.currentComponentIdx)}
                          setCurrentPage={() => this.setCurrentPage(this.state.currentPageIdx)}
                        />
                      </>
                    }
                    <div ref={lateralBottom => { this.lateralBottom = lateralBottom; }} />
                  </LateralMenuWrapper>
                </Col>
                <Col xl={13} xxl={13}>
                  <ContentlMenuWrapper>
                    <h1 style={{ paddingLeft: '38px' }}>{I18n.l('formflow.componentsModal.title')}</h1>
                    <SortableList key={this.state.processComponetListKey} items={this.renderProcessComponents()} onSortEnd={this.onSortEndComponent} useDragHandle={true} />
                    <Row className='cursor-page-style'>
                      <Col onClick={this.showComponents} xl={2} xxl={1} >
                        <Icon className='add-icon-style' color=' #1890ff' size='3x' icon={faPlusCircle} />
                      </Col>
                      <Col onClick={this.showComponents} className='add-button-style' xl={14} xxl={10} >
                        <span>{I18n.l("formflow.buttons.addComponent")}</span>
                      </Col>
                    </Row>
                    {this.state.componentsVisible &&
                      <Row>
                        <Col sm={8} md={8} xl={8} xxl={8}>
                          <ComponentsBox>
                            <div className="desc-options-container">
                              <MenuComponent
                                onClickComponent={this.handleAddNewComponent}
                                onMouseOverMenu={this.changeMenuText}
                                activeTooltip={this.state.selectedComponent}
                              />
                            </div>
                          </ComponentsBox>
                        </Col>
                        <Col style={{ marginLeft: '20px' }} sm={15} md={15} xl={15} xxl={15}>
                          <ComponentsHelpBox>
                            <Row>
                              <Col span={12}>
                                <div className="desc-content-container">
                                  {returnDesc(this.state.selectedComponent)}
                                </div>
                              </Col>
                              <Col span={12}>
                                <div className="gif-container">
                                  {returnGif(this.state.selectedComponent)}
                                </div>
                              </Col>
                            </Row>
                          </ComponentsHelpBox>
                        </Col>
                      </Row>
                    }
                    <div ref={contentBottom => { this.contentBottom = contentBottom; }} />
                  </ContentlMenuWrapper>
                </Col>
                <Col xl={6} xxl={6}>
                  <ComponentPreview process={this.state.processPages} forceReload={this.state.processPages.length < 10 ? false : this.state.forceReload} />
                  {this.state.processPages.length > 10 &&
                    <Button className='update-preview-button' type='primary' onClick={() => this.setForceReload()}>{I18n.l('common.update')}</Button>
                  }
                </Col>
              </Row>

            </>
          }
        </ProcessContext.Provider>
      </Wrapper>
    );
  }
}

export const ProcessContainerPage = Form.create()(ProcessContainer);
//#region CSS

const Wrapper = styled.div`
    width: 100%;
    height:100%;
    margin-left: ${({ theme }) => theme.sidebarSize || '180px'};
    margin-top: ${({ theme }) => theme.headerHeight || '150px'};
    .cursor-page-style{
        cursor: pointer;
        margin-top: 1rem;
        margin-left: 1.3rem;
        margin-bottom: 4rem;
      }
.add-button-style {
  font-weight: 500;
  font-size: 14px;
  line-height: 42px;
  color: #354D62;
}
.add-icon-style {
    padding-right:10px;
}
.cursor-component-style{
  cursor: pointer;
  margin-top: 1rem;
  margin-left: 20px;
  margin-bottom: 4rem;
}

.update-preview-button {
  position: absolute;
  top: 3%;
  margin-left: 1%
}

.page-container {
  position: relative;
  .page-end {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background-color: #1890ff87
  }
}
`

const HeaderWrapper = styled.div`
  height: 65px;
  margin-top: -23px;
  background-color: ${Theme.secondary.white};
  padding-bottom: 2rem;
  border-bottom: 1px solid  ${Theme.secondary.midGrey};
  display: flex;
.input-name-process{
   width: 60%;
}
.header-form{
  display: flex;
  flex: 1;
  justify-content: flex-start;
  .ant-form ,.ant-form-horizontal{
    width: 100%;
  }
}
.allowed-group-select{
  display: flex;
  flex: 1;
  justify-content: flex-start;
  .group-modal-button{
    margin-left: 3%;
    width: 300px;
    height: 40px;
  }
}
`

const GroupsModalContainer = styled.div`
    height: 60vh;
    padding: 30px;
    overflow: auto;
    .checkboxes{
      display: flex;
      flex-direction: column;
      width: 100%;
      margin-left: 1%;
        p{
        font-size: 1.5em;
        display: inline-block;
        margin-left: 5%;
        }
    }
`

const LateralMenuWrapper = styled.div`
        height:80vh;
        overflow-y: scroll;
        padding: 1rem 0 0 0;
::-webkit-scrollbar {
            width: 10px;
        }
h1 {
            color: #354D62;
        }
        
::-webkit-scrollbar-track {
            background: #f1f1f1;
        }
        
::-webkit-scrollbar-thumb {
            background: #888;
        }
        
::-webkit-scrollbar-thumb:hover {
            background: #555;
        }
        `

const ContentlMenuWrapper = styled.div`
        height:80vh;
        padding: 1rem 0 0 0;
        overflow-y: scroll;
        background-color: #F6FCFD;
::-webkit-scrollbar {
            width: 10px;
        }
        
h1 {
            color: #354D62
        }
        
::-webkit-scrollbar-track {
            background: #f1f1f1;
        }
        
::-webkit-scrollbar-thumb {
            background: #888;
        }
        
::-webkit-scrollbar-thumb:hover {
            background: #555;
        }
        
        `

const ComponentsBox = styled.div`
  @media only screen and (max-height: 768px){
        width: 100%;
        height: 61vh;
  }
        width: 100%;
        height: 63vh;
        margin-top: -65px;
        margin-left: 20px;
box-shadow: 0px 4px 10px 1px ${Theme.secondary.lightGrey};
          overflow: scroll;
          overflow-x: hidden;
background-color: ${Theme.secondary.white};
          margin-bottom: 100px;
::-webkit-scrollbar {
            width: 10px;
        }
        
::-webkit-scrollbar-track {
            background: #f1f1f1;
        }
        
::-webkit-scrollbar-thumb {
            background: #888;
        }
        
::-webkit-scrollbar-thumb:hover {
            background: #555;
        }
        `

const ComponentsHelpBox = styled.div`
@media only screen and (max-height: 768px){
        width: 100%;
        height: 61vh;
  }
        width: 100%;
        height: 63vh;
        margin-bottom: 100px;
        display: flex;
        margin-top: -65px;
        box-shadow: 5px 5px 10px ${Theme.secondary.lightGrey};
        overflow: hidden;
        background-color: ${Theme.secondary.white};
        margin-bottom: 100px;
::-webkit-scrollbar {
            width: 10px;
        }
.desc-content-container {
  padding: 15px 20px;
  background-color: #f1f1f1;
  text-align: left;
  height: 100vh;
  .title-text{
            font-size: 25px;
          font-weight: 600;
        }
      }
      
.gif-container{
  width: 100%;
  height: 600px;

  img {
    width: 100%
  }
}
`
